import RNSecureStorage from 'react-secure-storage';

export const storeJwt = (jwt: string) => RNSecureStorage.setItem('jwt', jwt);

export const storeRefreshToken = (refreshToken: any) => RNSecureStorage.setItem('jwt-refresh-token', refreshToken);

export const retrieveJwt = () => RNSecureStorage.getItem('jwt');

export const retrieveRefreshToken = () => RNSecureStorage.getItem('jwt-refresh-token');

export const removeJwt = () => RNSecureStorage.removeItem('jwt');

export const setLogoutGlobally = () => RNSecureStorage.setItem('logout', Date.now().toString());

export const removeRefreshToken = () => RNSecureStorage.removeItem('jwt-refresh-token');

export const clearStorage = () => RNSecureStorage.clear();

export const storeReferalCode = (ref: string) => RNSecureStorage.setItem('referral', ref);
export const retreieveReferalCode = () => RNSecureStorage.getItem('referral');
export const removeReferalCode = () => RNSecureStorage.removeItem('referral');

/** Contest / campaign commission promo code (?ref= on contest pages, or ?commission_code=). */
export const storeCommissionRefCode = (code: string) => RNSecureStorage.setItem('commission_ref', code);
export const retrieveCommissionRefCode = () => RNSecureStorage.getItem('commission_ref');
export const removeCommissionRefCode = () => RNSecureStorage.removeItem('commission_ref');
